import React from "react";
import { useCurrency } from "@/context/CurrencyContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const CURRENCIES = [
  { code: "chf", label: "CHF" },
  { code: "eur", label: "EUR" },
];

export const CurrencySwitcher = () => {
  const { currency, setCurrency } = useCurrency();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="currency-switcher-trigger"
          className="text-xs tracking-luxe uppercase text-[#1A1F2C] hover:text-[#C5A880] transition-colors duration-300">
          {currency.toUpperCase()}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none border-[#EAE6E1] min-w-[100px]">
        {CURRENCIES.map((c) => (
          <DropdownMenuItem key={c.code} data-testid={`currency-option-${c.code}`}
            onClick={() => setCurrency(c.code)}
            className={`text-xs tracking-luxe uppercase cursor-pointer ${currency === c.code ? "text-[#C5A880]" : ""}`}>
            {c.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
